export const DISCOUNT_CONDITIONS = [
  {
    id: 1,
    title: 'Ипотечная ставка',
    descr: 'на 2 года',
    percent: '21%',
    basePercent: '25%',
    notice: 'ПСК: 22,587% до 26,492%',
  },
  { id: 2, title: 'Первоначальный взнос', percent: '30%' },
  { id: 3, title: 'Скидка на стоимость квартиры', percent: '4,1%' },
];
